import { useState, useRef, useEffect } from 'react';

export interface DropdownItem {
    id: string;
    label: string;
    icon?: string;
    onClick: () => void;
}

interface DropdownProps {
    trigger: React.ReactNode;
    items: DropdownItem[];
    className?: string;
}

export const Dropdown: React.FC<DropdownProps> = ({ trigger, items, className = '' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleItemClick = (item: DropdownItem) => {
        item.onClick();
        setIsOpen(false);
    };

    return (
        <div className={`relative ${className}`} ref={dropdownRef}>
            <div onClick={toggleDropdown}>
                {trigger}
            </div>

            {isOpen && (
                <div className="absolute right-0 top-full mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
                    <div className="py-2">
                        {items.map((item) => (
                            <div
                                key={item.id}
                                onClick={() => handleItemClick(item)}
                                className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 cursor-pointer transition-colors"
                            >
                                {item.icon && <img src={item.icon} alt="icon" className="w-4 h-4" />}
                                <span className="text-sm font-regular font-clash-display text-medium-dark-grey">
                                    {item.label}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};
